import { Row } from 'antd'
import styled from 'styled-components'

const StyledDishListFooter = styled(Row)`
  padding: 8px;
`

export default StyledDishListFooter
